module.exports = __webpack_public_path__ + "img/gantan.5378a2d.png";